<template>
  <section
    v-editable="blok"
    :class="`${blok.variation} container article-text${animationClass}`"
  >
    <div class="row">
      <div :class="setColumns" class="col-12">
        <h3 class="article-text__title">{{ blok.title }}</h3>
        <!-- eslint-disable vue/no-v-html -->
        <div
          class="article-text__content"
          v-html="blok.content[0].text.content"
        />
        <!-- eslint-enable -->
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ArticleText',
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: () => false,
    },
    animateWhenVisible: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      animationClass: '',
    }
  },
  computed: {
    setColumns() {
      return this.blok.variation === 'article-text--left' ? 'col-md-6' : ''
    },
  },
  watch: {
    visible(visible) {
      if (visible) {
        this.animationClass = ' article-text--animate article-text--animate-in'
      } else {
        this.animationClass =
          ' article-text--animate article-text--animate-done'
      }
    },
  },
  mounted() {
    if (this.animateWhenVisible) {
      this.animationClass = ' article-text--animate'
    }
  },
}
</script>

<style lang="scss">
@import '../../../assets/scss/settings';

.article-text {
  padding-top: spacer(3);
  padding-bottom: spacer(3);

  &--animate {
    .article-text__title,
    .article-text__content {
      opacity: 0;
      transform: translate(0, 30px);
      transition: all 0.3s ease-out 0.2s;
    }
    &-done {
      .article-text__title,
      .article-text__content {
        opacity: 1;
        transform: translate(0, 0);
      }
    }
    &-in {
      .article-text__title,
      .article-text__content {
        opacity: 1;
        transform: translate(0, 0);
      }
    }
  }

  &__title {
    @include font-size(34);
    @include font-family($font-family-headings-bold);

    margin-top: 0;
    margin-bottom: spacer(3);
  }

  &__content {
    @include font-family($font-family-text);
    p {
      margin: 0 0 10px 0;
    }

    ul {
      @include font-size(30, rem-v(28));

      padding: 0;
      margin-top: 50px;
      margin-bottom: 0;
    }

    li {
      padding-left: 30px;
      margin-left: 25px;
      margin-bottom: 25px;

      span,
      li {
        @include font-size(16);
      }
    }
  }
}

@include media-breakpoint-up(md) {
  .article-text {
    &__title {
      margin-bottom: spacer(1);
    }

    /* &--single {
      max-width: 800px;
    } */

    &--double {
      .article-text__content {
        column-count: 2;
        column-gap: 30px;
      }
    }

    &--triple {
      .article-text__content {
        column-count: 3;
        column-gap: 30px;
      }
    }
  }
}
</style>
